import { Injectable, Injector } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Chat } from "../../../bayadic-shared-models/chat/Chat";
import { User } from "../../../bayadic-shared-models/classes/user/User";
import { Member } from '../../../bayadic-shared-models/classes/system/member/Member';


/*
  Generated class for the SpaceRepetitionDatabaseManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MembersDatabaseManagerProvider {
  //private friendTableName = "friends";
  constructor(
    public injector: Injector,
    public platform: Platform) {
    this.init().then(() => {

      this.createMembersTable();
    });

  }
  add(member: Member, chat: Chat) {
    // let sqlString = "INSERT INTO members (chatID,userID,role,name,email) VALUES ('"+
    // chat.chatID+"','"+
    // member.userID+"','"+
    // member.role+"','"+
    // member.name+"','"+
    // member.email + "')";
    let sqlString = `INSERT INTO members (chatID,userID,role,name,email) SELECT "` +
      chat.chatID + `","` +
      member.userID + `","` +
      member.roleOf + `","` +
      member.name + `","` +
      member.email + `" `;
    sqlString += "where NOT EXISTS(SELECT 1 FROM members WHERE chatID = '" + chat.chatID
      + "' AND userID = '" + member.userID + "')";

    // executeSql(statement: string, params?: any[]): Promise<any>;
    // this.databaseObj.executeSql(sqlString).then(
    //   () => {
    //     this.logger.debug("member has beend added successfully");
    //   })
    //   .catch(e => {
    //     this.logger.debug(" there was  an error adding member to database", e);
    //   })
  }
  remove(member: Member, chat: Chat) {
    // let sqlString = `INSERT INTO members (chatID,userID,role,name,email) VALUES ("`+
    let sqlString = `DELETE from members where chatID = "` +
      chat.chatID + `"  AND userID ="` +
      member.userID + `"`;
    // this.databaseObj.executeSql(sqlString).then(
    //   () => {
    //     this.logger.debug("member has beend removed successfully");
    //   })
    //   .catch(e => {
    //     this.logger.debug(" there was  an error removing member from database", e);
    //   })
  }
  getMembers(chat: Chat): Promise<Array<Member>> {
    return new Promise((resolve) => {
      let members = [];
      if (!this.platform.is("cordova"))
        resolve(members);
      else {

        this.init().then(() => {
        })
      }
    });
  }
  getMeAsMember(chat: Chat, user: User): Promise<Member> {
    return new Promise((resolve) => {
      let member: Member;
      this.init().then(() => {
      })
    });
  }
  getAdmins(chat: Chat): Promise<Array<Member>> {
    return new Promise((resolve) => {
      let admins = [];
      this.init().then(() => {
      })
    });
  }
  async init() {
   
  }
  createMembersTable() {

    
    // this.databaseObj.executeSql('create table  IF NOT EXISTS members \n\
    //   (chatID  VARCHAR(32),userID  VARCHAR(32),role VARCHAR(32),name VARCHAR(32),email VARCHAR(32) )', [])
    //   .then(() => {
    //     this.logger.debug('created table of members SQL');
    //   })
    //   .catch(e => {
    //     this.logger.debug(e)
    //   });
  }

}
